import { IEditorConfig, IToolbarConfig } from '@wangeditor/editor';
import { Editor, Toolbar } from '@wangeditor/editor-for-react';
import '@wangeditor/editor/dist/css/style.css'; // 引入 css
import { Button, Col, Form, Input, Row, Select, Switch, message, DatePicker } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import servicePath from '../config/apiUrl';
import '../static/css/AddArticle.css';
import moment from 'moment';
const { Option } = Select;

function AddNews(props) {

    const [hideSW, setHideSW] = useState(false);
    const [posturl, setPosturl] = useState();
    const [newsType, setNewsType] = useState([]);
    const [postFile, setPostFile] = useState(null);
    const [fields, setFields] = useState([]);
    const [newsId, setNewsId] = useState(props.match.params.id)  // 文章的ID，如果是0说明是新增加，如果不是0，说明是修改
    const [adTitle, setNewsTitle] = useState('')   //文章标题
    const [description, setDescription] = useState('')   //文章小标题 描述
    const [author, setAuthor] = useState('')   //文章作者
    const [external_link, setExtLink] = useState('')   //文章外链
    const [updateTime, setUpdateTime] = useState(null)  // 更新时间

    // editor 实例
    const [editor, setEditor] = useState(null)   // TS 语法

    // 编辑器内容
    const [richTextContent, setRichTextContent] = useState('<dvi> </dvi>')

    useEffect(() => {
        getNewsType()
        setNewsId(props.match.params.id)
        if (props.match.params.id) {
            getNewsInfo()
        }
    }, [props.match.params.id])


    // 工具栏配置
    const toolbarConfig: Partial<IToolbarConfig> = {}  // TS 语法
    // const toolbarConfig = { }                        // JS 语法

    // 编辑器配置
    const editorConfig: Partial<IEditorConfig> = {    // TS 语法
        // const editorConfig = {                         // JS 语法
        placeholder: '请输入内容...',
        MENU_CONF: {}

    }
    editorConfig.MENU_CONF['uploadImage'] = {
        server: servicePath.serverUrl + '/admin/uploadImage',
        // fieldName: 'customImg'
        // 继续写其他配置...
        //【注意】不需要修改的不用写，wangEditor 会去 merge 当前其他配置
    }
    editorConfig.MENU_CONF['uploadVideo'] = {
        server: servicePath.serverUrl + '/admin/uploadVideo',
        // fieldName: 'customImg'
        // 继续写其他配置...
        //【注意】不需要修改的不用写，wangEditor 会去 merge 当前其他配置
    }


    // 及时销毁 editor ，重要！
    useEffect(() => {
        return () => {
            if (editor == null) return
            editor.destroy()
            setEditor(null)
        }
    }, [editor])

    // getNewsType 获取知识库文章分类型
    const getNewsType = () => {
        axios({
            method: 'get',
            url: servicePath.getNewsType,
        }).then(
            res => {
                if (res.data.code == 1) {
                    setNewsType(res.data.list || [])
                } else {
                    message.error('获取知识库文章类型失败')
                }
            }
        )
    }

    //获取编辑文章的默认数据
    const getNewsInfo = () => {
        const hide = message.loading('...', 0);
        axios({
            method: 'get',
            url: servicePath.getNewsInfo + "/" + newsId,
        }).then(
            res => {
                setTimeout(hide, 100);
                if (res.data.code == 1) {
                    setPosturl(res.data.data.post_url)

                    let resData = res.data?.data || {}
                    setHideSW(resData.hide == 1 ? 0 : 1)
                    setRichTextContent(resData.rich_text_content)
                    setNewsId(resData.newsId)
                    
                    // 修改日期格式处理
                    let updateTimeValue = null;
                    if (resData.update_time) {
                        // 使用完整的日期时间格式
                        updateTimeValue = moment(resData.update_time, 'YYYY-MM-DD HH:mm:ss');
                    }
                    setUpdateTime(updateTimeValue);

                    setFields([
                        // {
                        //   name:['user', 'newsId'],
                        //   value: resData.newsId,
                        // },
                        {
                            name: ['user', 'adTitle'],
                            value: resData.title,
                        },
                        {
                            name: ['user', 'description'],
                            value: resData.description,
                        },
                        {
                            name: ['user', 'update_time'],
                            value: updateTimeValue,
                        },
                        {
                            name: ['user', 'external_link'],
                            value: resData.external_link,
                        },


                        {
                            name: ['user', 'author'],
                            value: resData.author,
                        },
                        {
                            name: ['user', 'type'],
                            value: resData.type,
                        }, {
                            name: ['user', 'post_url'],
                            value: resData.post_url,
                        }
                    ])

                } else {
                    console.log("未查到相关文章数据:", res.data)
                }


            }
        )

    }

    const validateMessages = {
        required: '${label} 必须填写!',
        types: {
            email: '${label} is not validate email!',
            number: '${label} is not a validate number!',
        },
        number: {
            range: '${label} must be between ${min} and ${max}',
        },
    };

    const onFinish = values => {
        const key = 'addData';
        let fromData = values.user;
        if (!fromData.adTitle) {
            message.error('标题不能为空')
            return false
        } if (!fromData.description) {
            message.error('小标题（描述）不能为空')
            return false
        } if (!fromData.type) {
            message.error('文章类型不能为空')
            return false
        } else if (!postFile && !posturl) {
            message.error('海报图片不能为空')
            return false
        } else if (!richTextContent) {
            message.error('文章页面详情内容')
            return false
        }

        var formData = new FormData();
        formData.append("title", fromData.adTitle);
        formData.append("description", fromData.description);
        formData.append("author", fromData?.author || '');
        formData.append("type", fromData.type);
        formData.append("external_link", fromData.external_link);
        formData.append("hide", hideSW ? 0 : 1);
        formData.append("data_url", fromData.data_url);
        formData.append("rich_text_content", richTextContent);
        // 添加更新时间
        if (fromData.update_time) {
            formData.append("update_time", fromData.update_time.format('YYYY-MM-DD HH:mm:ss'));
        }
        
        // 保存
        let url = servicePath.addNewsInfo
        let msg = '添加文章信息成功！'
        let errMsg = '添加文章信息失败！'

        if (newsId) {
            if (postFile) {
                formData.append("post_url", postFile);
            }
            // 修改文章内容
            formData.append("newsId", newsId);
            url = servicePath.editNewsInfo
            msg = '修改文章信息成功！'
            errMsg = '修改文章信息失败！'

        } else {
            formData.append("post_url", postFile);
        }
        message.loading({ content: '保存数据...' });
        axios({
            method: 'POST',
            url: url,
            data: formData,
            // withCredentials: true,
            headers: { 'Content-Type': 'multipart/form-data' }
            // header: { 'Access-Control-Allow-Origin': '*' }
        }).then(
            res => {
                if (res.data.code == 1) {
                    message.success({ content: msg, key, duration: 2 });
                    setTimeout(() => {
                        props.history.push('/news/list')
                    }, 2000)
                } else {
                    message.error({ content: errMsg, key, duration: 2 });
                }


            }
        ).catch((res) => {
            message.error({ content: '添加文章失败！', key, duration: 2 });
        })
    };


    const layout = {
        labelCol: { span: 5 },
        wrapperCol: { span: 15 },
    };
    const getUrl = values => {

        var file = document.getElementById("upload")
        var preview = document.getElementById("preview");


        // 创建文件读取对象
        var reader = new FileReader();
        // 用户选择的文件列表
        // postFile = file.files[0];
        setPostFile(file.files[0])
        // 读取文件
        reader.readAsDataURL(file.files[0]);
        // 监听onload事件
        reader.onload = function () {
            console.log(reader.result);
            // 将读取的结果显示在页面中
            preview.src = reader.result;
            preview.style.display = 'block'
        }

    };
    const clSwitch = (checked, event) => {
        // setHideSW
        setHideSW(!hideSW)
    }
    return (
        <>
            <Form {...layout} name="nest-messages" fields={fields} onFinish={onFinish} method="post" enctype="multipart/form-data" validateMessages={validateMessages}>
                <div>
                    <Row gutter={12}>
                        <Col span={20}>
                            {newsId && <Form.Item name={['user', 'newsId']} label="文章Id" >
                                <Input defaultValue={newsId} maxLength='10' disabled={1} />
                            </Form.Item>}
                            <Form.Item name={['user', 'adTitle']} label="标题" rules={[{ required: true, message: '必填' }]}>
                                <Input defaultValue={adTitle} />
                            </Form.Item>
                            <Form.Item name={['user', 'description']} label="小标题（描述）" rules={[{ required: true, message: '必填' }]}>
                                <Input defaultValue={description} />
                            </Form.Item>
                            <Form.Item name={['user', 'update_time']} label="更新时间">
                                <DatePicker 
                                    showTime 
                                    format="YYYY-MM-DD HH:mm:ss" 
                                    placeholder="选择更新时间"
                                    style={{ width: '100%' }}
                                />
                            </Form.Item>
                            <Form.Item name={['user', 'author']} label="作者" rules={[{ message: '必填' }]}>
                                <Input placeholder='原创：xxx' defaultValue={author} />
                            </Form.Item>
                            <Form.Item name={['user', 'external_link']} label="外部链接">
                                <Input placeholder='有值就跳转，否则进入详情页' defaultValue={author} />
                            </Form.Item>
                            <Form.Item name={['user', 'type']} label="文章类型：" rules={[{ required: true, message: '必填' }]}>
                                {/* onChange={selectTypeHandler} */}
                                <Select style={{ width: '200px' }} placeholder="请选择文章类型" size="large" >
                                    {/* <Option key={"1"} value={'small'}>小</Option>
                                    <Option key={"2"} value={'big'}>大</Option> */}
                                    {/* newsType 给opt 设置循环遍历 */}
                                    {newsType.map((item) => <Option key={item.id} value={item.id}>{item.name}</Option>)}

                                </Select>
                            </Form.Item>
                            <Form.Item name={['user', 'post_url']} label="海报图" >
                                <input onChange={() => { getUrl() }} type="file" placeholder="选择上传海报图" accept="image/*" id="upload" ></input>
                                {(newsId && posturl) && <img style={{ width: '200px', height: 'auto', minHeight: '20px', padding: '20px 0' }} id="preview" src={servicePath.serverUrl + posturl} />}
                                <img style={{ width: '200px', height: 'auto', minHeight: '20px', padding: '20px 0', display: 'none' }} id="preview" src={servicePath.serverUrl + posturl} />
                                <div style={{ padding: '10px 0' }}>建议图片尺寸：( 160px * 160px )</div>
                            </Form.Item>
                            <Form.Item name={['user', 'hide']} label="是否显示" >
                                <Switch checked={hideSW} onClick={() => { clSwitch() }} />
                            </Form.Item>
                            <Form.Item label="文章页面详情内容" >
                                <div style={{ border: '1px solid #ccc', zIndex: 100 }}>
                                    <Toolbar
                                        editor={editor}
                                        defaultConfig={toolbarConfig}
                                        mode="default"
                                        style={{ borderBottom: '1px solid #ccc' }}
                                    />
                                    <Editor
                                        defaultConfig={editorConfig}
                                        value={richTextContent}
                                        onCreated={setEditor}
                                        onChange={editor => setRichTextContent(editor.getHtml())}
                                        mode="default"
                                        style={{ height: '500px', overflowY: 'hidden' }}
                                    />
                                </div>
                            </Form.Item>

                        </Col>

                        <Col span={4}>
                            <Row>
                                <Col span={24}>
                                    {newsId && <Button type="primary" size="large" htmlType="submit">修改文章信息</Button>}
                                    {!newsId && <Button type="primary" size="large" htmlType="submit" >发布文章</Button>}
                                </Col>
                            </Row>

                        </Col>
                    </Row>
                </div>
            </Form >
        </>
    )
}
export default AddNews